import gql from 'graphql-tag';

export default gql`
  query product($id: ID!) {
    product(id: $id) {
      id
      intId
      name
      nameVn
      description
      descriptionVn
      productGroups
      details
      detailsVn
      imageUrl
      imageFilePath
      origin
      preservation
      unitPrice {
        vat
        value
        vatIncluded
      }
      uom
      baseUom
      baseUnit
      netUom
      netUnit
      category
      disabled
      createdAt
      updatedAt
      offMarket
      private
      internalCode
      tags
      limitedTimeOffer {
        price {
          value
        }
        period {
          start
          end
        }
      }
      brandId
      productInfoByRegion {
        itemId
        regionCode
        price
        inStock
        exclusive
        limitedTimeOffer {
          price {
            value
            vat
            vatIncluded
          }
          period {
            start
            end
          }
        }
        oosReason {
          code
          description
          restockDate
        }
      }
      medias {
        type
        url
        name
        isPrimary
      }
      groupType
      vatDisplayInvoice
      vatRule
      futurelog
    }
  }
`;
